function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Lock Locked"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 24,
  "data-height": 28,
  className: "iconic-container iconic-lock-locked",
  transform: "scale(1 1 ) translate(4 2 ) "
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M5.5 14v-6c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5v6",
  className: "iconic-lock-locked-loop iconic-property-accent iconic-property-stroke",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-lock-locked-body iconic-lock-locked-body-main iconic-property-fill",
  d: "M0 12h24v11h-24z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconic-lock-locked-body iconic-lock-locked-body-top iconic-property-fill",
  d: "M0 24h24v4h-24z"
}));

function SvgLockLockedMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "lock-locked",
    width: 32,
    height: 32,
    className: "iconic iconic-lock iconic-size-md iconic-lock-locked",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLockedMd);
export default __webpack_public_path__ + "static/media/lock-locked-md.ee0e56c7.svg";
export { ForwardRef as ReactComponent };